import { gql } from 'graphql-request'
import { useMutation, UseMutationResult } from '@/proxy/react-query'

import { client } from '@/proxy/client'

import { monitorGraphqlOperation } from '../useChangeOrderStatus/datadogGraphql'
import type {
  BatchChangeOrderStatusInput,
  BatchChangeOrderStatusResponse,
} from './types'

export const BATCH_CHANGE_ORDER_STATUS = gql`
  mutation batchChangeOrderStatus(
    $orders: [String!]!
    $status: OrderStatus!
    $reasons: String
  ) {
    batchChangeOrderStatus(
      orders: $orders
      status: $status
      reasons: $reasons
    ) {
      orderNumber
      success
    }
  }
`

const isBatchChangeOrderStatusResponse = (
  result: unknown
): result is BatchChangeOrderStatusResponse =>
  typeof result === 'object' &&
  result !== null &&
  'batchChangeOrderStatus' in result &&
  Array.isArray(
    (result as BatchChangeOrderStatusResponse).batchChangeOrderStatus
  )

export const useBatchChangeOrderStatus = (): UseMutationResult<
  BatchChangeOrderStatusResponse,
  Error,
  BatchChangeOrderStatusInput
> =>
  useMutation({
    mutationFn: async (
      variables: BatchChangeOrderStatusInput
    ): Promise<BatchChangeOrderStatusResponse> => {
      const result: unknown = await monitorGraphqlOperation({
        operationName: 'batchChangeOrderStatus',
        variables,
        request: () => client.request(BATCH_CHANGE_ORDER_STATUS, variables),
      })

      if (isBatchChangeOrderStatusResponse(result)) {
        return result
      }

      throw new Error(
        'Invalid response structure from batchChangeOrderStatus mutation'
      )
    },
  })
